'use strict';

module.exports = [
  '$provide',
  ionicListDelegateDecorator];

function ionicListDelegateDecorator($provide) {
  var swipeBreakpoint = 680;
  var canSwipe = true;

  $provide.decorator('$ionicListDelegate', [
    '$delegate',
    '$window',
    '$ionicPlatform',
    '$rootScope',
    decorateService]);

  function decorateService($delegate, $window, $ionicPlatform, $rootScope) {
    try {
      var _registerInstance = Object.getPrototypeOf($delegate)._registerInstance;

      $delegate._registerInstance = function (instance, handle, filterFn) {
        if (!canSwipe) {
          $rootScope.$evalAsync(function () {
            instance.canSwipeItems(false); // we must want one tick to do this due to the way Ionic declares their controller functions
          });
        }

        return _registerInstance.call(this, instance, handle, filterFn);
      };

      $ionicPlatform.ready(function () {
        try {
          canSwipe = $window.innerWidth < swipeBreakpoint;
          $delegate.canSwipeItems(canSwipe);
        } catch (e) {
          setTimeout(function () {
            canSwipe = $window.innerWidth < swipeBreakpoint;
            $delegate.canSwipeItems(canSwipe);
          }, 5000)
        }
        $window.addEventListener('resize', function (event) {
          $window.requestAnimationFrame(function () {
            canSwipe = $window.innerWidth < swipeBreakpoint;
            $delegate.canSwipeItems(canSwipe);
            if (!canSwipe) {
              $delegate.closeOptionButtons()
            }
          })
        });
      });
    } catch (e) {
      // old browser, Object.getPrototypeOf not supported. Abort
    }

    return $delegate;
  }

}


// WEBPACK FOOTER //
// ./src/js/core-utilities-implementation/ionic-delegates/ionicListDelegateDecorator.js